// extracted by mini-css-extract-plugin
export default {"solucoes-container":"NossasSolucoes_solucoes-container__K0CZ8","solucoes-section":"NossasSolucoes_solucoes-section__zgeAU","button":"NossasSolucoes_button__F07Qh"};